// src/components/Logo.tsx
import React from 'react';
import { useNavigate } from 'react-router-dom';

const Logo: React.FC<{ className?: string }> = ({ className }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate('/spaces');
  };

  return (
    <h1 
      className={`text-2xl font-bold text-center lg:text-3xl cursor-pointer ${className}`} 
      onClick={handleClick}
    >
      BIN-G<span className="text-orange-500">O</span>
    </h1>
  );
};

export default Logo;
